import React from "react";

export const ResetPassword = () => {
    return (
        <div>
            <h1>You have reset your password</h1>
        </div>
    );
};
